export interface NormalizedStatisticSegment {
  target_block: string;
  dimension: string;
  dimension_title?: string;
  description: string;
  values: Record<string, number>;
}

/** Normalize segment JSON from imports, AI output, or nested shapes. */
export function normalizeStatisticSegment(
  segment: unknown,
  index = 0
): NormalizedStatisticSegment {
  const raw = segment as Record<string, unknown> | null | undefined;
  const source =
    raw?.segment && typeof raw.segment === 'object'
      ? (raw.segment as Record<string, unknown>)
      : raw ?? {};

  const dimensionTitle =
    (source.dimension_title as string | undefined) ||
    (source.title as string | undefined) ||
    (source.name as string | undefined);

  const dimension =
    (source.dimension as string | undefined) ||
    (source.dimension_name as string | undefined) ||
    (source.name as string | undefined) ||
    (source.id as string | undefined) ||
    (source.key as string | undefined) ||
    (typeof dimensionTitle === 'string'
      ? dimensionTitle.toLowerCase().replace(/\s+/g, '_')
      : `segment_${index + 1}`);

  const values = source.values;
  const normalizedValues =
    values && typeof values === 'object' && !Array.isArray(values)
      ? (values as Record<string, number>)
      : {};

  return {
    target_block:
      (source.target_block as string | undefined) ||
      (source.targetBlock as string | undefined) ||
      '',
    dimension: String(dimension),
    dimension_title: dimensionTitle || undefined,
    description: (source.description as string | undefined) || '',
    values: normalizedValues,
  };
}

export function formatSegmentLabel(segment: {
  dimension?: string;
  dimension_title?: string;
}): string {
  const label =
    segment.dimension_title ||
    segment.dimension?.replace(/_/g, ' ') ||
    'Segmento';
  return label.replace(/\b\w/g, (letter) => letter.toUpperCase());
}
